import { updateCurrentProject } from "../project/projects-state"
import { store } from "../store"
import { isPhotoStorageAvailableAtom } from "./pixieset-state"

export const clearPixiesetCollectionSelection = () => {
	store.set(isPhotoStorageAvailableAtom, undefined)
	void updateCurrentProject({
		publishCollectionId: undefined,
		publishGalleryId: undefined,
	})
}
